// extracted by mini-css-extract-plugin
export default {"App":"inputCode_App__pLVwa","code_input":"inputCode_code_input__XmPKk","code_label":"inputCode_code_label__ak86x","code_inputs":"inputCode_code_inputs__7s94H"};